import Intro from '../../components/Intro/Intro'
import DefaultLayout from '../../layouts/DefaultLayout/DefaultLayout'

const IntroPage = () => {
  return (
    <DefaultLayout>
      <Intro />
    </DefaultLayout>
  )
}

export default IntroPage
